function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.17209 441.884C1.17209 475.716 29.1721 503.716 63.0041 503.716H380.334C414.166 503.716 442.166 475.716 442.166 441.884L442.17 283.214H396.67V441.884C396.67 450.052 389.67 457.052 381.502 457.052L61.832 457.048C53.664 457.048 46.664 450.048 46.664 441.88L46.6679 124.55C46.6679 116.382 53.6679 109.382 61.8359 109.382H220.506L220.502 63.8861H61.832C28 63.8861 0 91.8861 0 125.718V441.888L1.17209 441.884Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M492.334 89.544C507.502 74.376 507.502 51.044 492.334 35.876L467.834 11.376C452.666 -3.792 429.334 -3.792 414.166 11.376L192.506 233.046L169.174 334.546L270.674 311.214L492.334 89.544Z",
  fill: "black"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 504,
    viewBox: "0 0 504 504",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.57a80120.svg";
export { ForwardRef as ReactComponent };